<template>
  <div class="replacementmonthlystatistics__report__view">
    <div class="reports__subheader">

      <year-panel @year="(value) => year = value">
      </year-panel>

      <submit-panel @submit="performLookup">
      </submit-panel>
      <submit-panel @submit="create" text="Opret ny" v-if="rates && rates.length === 0">
      </submit-panel>
    </div>
   
    <b-table :data="rates"
             :loading="loading"
             @click="editClick"
             hoverable style="cursor: pointer;">

      <b-table-column field="drivingRateWeekday"
                      label="Kørsel HV."
                      v-slot="props">
        {{ props.row.drivingRateWeekday | salarydecimal }}
      </b-table-column>
      <b-table-column field="drivingRateHoliday"
                      label="Kørsel SH."
                      v-slot="props">
        {{ props.row.drivingRateHoliday | salarydecimal }}
      </b-table-column>
      <b-table-column field="hourRateWeekdayDrivingBefore"
                      label="Kørsel før 07:15 HV."
                      v-slot="props">
        {{ props.row.hourRateWeekdayDrivingBefore | salarydecimal }}
      </b-table-column>
      <b-table-column field="hourRateWeekendDrivingBefore"
                      label="Kørsel før 07:15 SH."
                      v-slot="props">
        {{ props.row.hourRateWeekendDrivingBefore | salarydecimal }}
      </b-table-column>
      <b-table-column field="hourRateWeekday"
                      label="Time RTA HV."
                      v-slot="props">
        {{ props.row.hourRateWeekday | salarydecimal }}
      </b-table-column>
      <b-table-column field="hourRateHoliday"
                      label="Time RTA SH."
                      v-slot="props">
        {{ props.row.hourRateHoliday | salarydecimal }}
      </b-table-column>
      <b-table-column field="hourRateWeekdayAtk"
                      label="Time ATK HV."
                      v-slot="props">
        {{ props.row.hourRateWeekdayAtk | salarydecimal }}
      </b-table-column>
      <b-table-column field="hourRateHolidayAtk"
                      label="Time ATK SH."
                      v-slot="props">
        {{ props.row.hourRateHolidayAtk | salarydecimal }}
      </b-table-column>
      <b-table-column field="hourRateWeekdayMaternity"
                      label="Time barsel"
                      v-slot="props">
        {{ props.row.hourRateWeekdayMaternity | salarydecimal }}
      </b-table-column>
      <b-table-column field="pensionPercentage"
                      label="Pensions rate %."
                      v-slot="props">
        {{ props.row.pensionPercentage | salarydecimal }}
      </b-table-column>
      <b-table-column field="seniorityRate"
                      label="Anciennitet"
                      v-slot="props">
        {{ props.row.seniorityRate | salarydecimal }}
      </b-table-column>
      <b-table-column field="tariff"
                      label="Timer pr. session"
                      v-slot="props">
        {{ props.row.tariff | salarydecimal }}
      </b-table-column>
      
      <!-- <b-table-column field="employeeNumber"
                      label="Ins. nummer"
                      v-slot="props">
        {{ props.row.employeeNumber }}
      </b-table-column> -->
    </b-table>
    <b-loading :is-full-page="isFullPage" :active.sync="saving" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment, { ISO_8601 } from 'moment';
import APISTATE from '../../enums/APISTATE';
import YearPanel from '@/components/report/YearPanel.vue';
import SubmitPanel from '@/components/report/SubmitPanel.vue';

export default {
  name: "salary-rate-view",
  components: { SubmitPanel, YearPanel },
  data: () => ({ 
    isFullPage: true,
    saving: false
  }),
  async mounted() {
      const dto = {
        year: 2023,
        forUser: null
      };
      this.year = dto.year;
      await this.getAllSalaryRatesForYear(dto);
  },
  computed: {
    ...mapGetters("salaryRateStore", ["ratesApiState", "rates"]),
     loading() {
      return this.ratesApiState === APISTATE.LOADING;
    },
  },
  methods: {
    ...mapActions("salaryRateStore", ["getAllSalaryRatesForYear", 'createSalaryRate', "startEditingRate"]),
    async performLookup() {
      const dto = {
        year: this.year,
        forUser: this.employeeId
      };
      await this.getAllSalaryRatesForYear(dto);
    },
    async editClick(arg) {
      this.startEditingRate(arg);
    },
    async create() {
      await this.createSalaryRate({
        year: 2023
      });
      await this.performLookup();
    },
    dateFormat(arg) {
        return moment(arg).format('YYYY-MM-DD');
    }
  },
};
</script>

<style lang="scss" scoped>
.users-view {
  .register-user {
    cursor: pointer;
    width: 100%;
  }
}

.table td {
  text-align: left !important;
}
</style>
